<div [class.border-custom-gradient--light-display]="gradientBorder" class="border-custom-gradient">
    <div
        [class.container--light-display]="lightDisplay"
        [class.light-display]="lightDisplay"
        class="container theme-white-1-background theme-title"
    >
        <div>
            <div class="title">
                <img src="/assets/images/ksuite/ksuite-logo-only.svg" />
                <span>{{ 'kSuite, Collaborez dans un cloud ethique' | transloco }}</span>
            </div>
        </div>
        <div *ngIf="!lightDisplay">
            <div class="check-block">
                <img src="/assets/images/ui/check.svg" />
                <div>{{ 'Securite et vie privee garantie.' | transloco }}</div>
            </div>
            <div class="check-block">
                <img src="/assets/images/ui/check.svg" />
                <div>{{ 'Mise a jour gratuites et continues.' | transloco }}</div>
            </div>
            <div class="check-block">
                <img src="/assets/images/ui/check.svg" />
                <div>{{ 'Infrastructure et logiciel developpe et heberge en Suisse.' | transloco }}</div>
            </div>
            <div class="check-block">
                <img src="/assets/images/ui/check.svg" />
                <div>{{ 'Support 7/7 a Geneve et Winterthour' | transloco }}</div>
            </div>
        </div>
        <div>
            <div class="title2">
                {{ subtitleWording }}
                :
            </div>
            <div class="app">
                <div class="app-block">
                    <img src="/assets/images/ksuite/applications/mail.svg" />
                    <div class="app-block-right">
                        <span class="app-block-right-title">{{ 'Mail' }}</span>
                        <span class="app-block-right-desc">{{
                            'Pour gerer vos mails, contacts et rendez-vous.' | transloco
                        }}</span>
                    </div>
                </div>
                <div class="app-block">
                    <img src="/assets/images/ksuite/applications/kchat.svg" />
                    <div class="app-block-right">
                        <span class="app-block-right-title">{{ 'kChat' | transloco }}</span>
                        <span class="app-block-right-desc">{{
                            'Pour communiquer en direct et coordonner vos equipes.' | transloco
                        }}</span>
                    </div>
                </div>
                <div class="app-block">
                    <img src="/assets/images/ksuite/applications/domain.svg" />
                    <div class="app-block-right">
                        <span class="app-block-right-title">{{ 'Nom de domaine' | transloco }}</span>
                        <span class="app-block-right-desc">{{
                            "Votre ecosysteme a l'image de votre marque." | transloco
                        }}</span>
                    </div>
                </div>
                <div class="app-block">
                    <img src="/assets/images/ksuite/applications/drive.svg" />
                    <div class="app-block-right">
                        <span class="app-block-right-title">{{ 'kDrive' | transloco }}</span>
                        <span class="app-block-right-desc">{{
                            'Pour stocker vos donnees et collaborer en ligne.' | transloco
                        }}</span>
                    </div>
                </div>
                <div class="app-block">
                    <img src="/assets/images/ksuite/applications/kmeet.svg" />
                    <div class="app-block-right">
                        <span class="app-block-right-title">{{ 'kMeet' | transloco }}</span>
                        <span class="app-block-right-desc">{{
                            'Pour organiser vos reunions et travailler a distance.' | transloco
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            {{ 'Et de nombreuses autres applications...' | transloco }}
        </div>
    </div>
</div>
